export const administrator = 'Administrator';
export const reader = 'Reader';
export const master = 'Master';
export const superAdministrator = 'Super-administrator';
export const operator = 'Operator';
export const engineer = 'Engineer';

export const manualInputRoles: string[] = [master, engineer, operator];
